import $ from 'jquery';
import whatInput from 'what-input';
window.$ = $;

// import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';
import './lib/directory-filter-ajax';
import './lib/reward-form';
import './lib/multi-step-form';
import './lib/registration-form';
import './lib/profile';
import './lib/user-service-list';
import './lib/local-partners-ajax';
import './lib/bid-box';
import './lib/bulkZipForm';

/**
 * Custom Abide Validators
 */
Foundation.Abide.defaults.patterns['zip'] = /^\d{5}$/;
Foundation.Abide.defaults.patterns['phone'] = /^\d{10}$/;
Foundation.Abide.defaults.patterns['password'] = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{10,})/;
Foundation.Abide.defaults.patterns['county'] = /^.* (County|county)$/;

/**
 * Homepage Slider
 */
$(function() {
  const $slider = $('#homepage-slider');
  if ($slider.length) {
      const slider = new Foundation.Orbit($slider, {
          timerDelay: 5000,
          pauseOnHover: false,
          autoPlay: true,
      });
  }
});

/**
 * Sticky Menu
 */
$(function() {
  const $mainMenu = $('.top-bar');
  if ($mainMenu.length) {
    const stickyMenu = new Foundation.Sticky($mainMenu, {
      marginTop: 0,
      stickyOn: 'small',
    });
  }
});

$(document).foundation();
